import script from "./Items.vue?vue&type=script&setup=true&lang=js"
export * from "./Items.vue?vue&type=script&setup=true&lang=js"

import "./Items.vue?vue&type=style&index=0&id=79965194&scoped=true&lang=css"

import exportComponent from "/app/inventory-ui-actions-runner/_work/inventory-ui/inventory-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79965194"]])

export default __exports__